import moment from 'moment';
import { toDate } from '@/functions/transform';

/**
 * @param {Date|string} date
 *
 * @return {string}
 */
export const relativeTimeFilter = (date) => {
    if (!(date instanceof Date)) {
        date = toDate(date);
    }
    if (!date) {
        return '';
    }

    return moment(date).fromNow();
};
